import { render } from "./ListStockMovementsDetailRenderer.vue?vue&type=template&id=8e635602"
import script from "./ListStockMovementsDetailRenderer.vue?vue&type=script&lang=js"
export * from "./ListStockMovementsDetailRenderer.vue?vue&type=script&lang=js"

import "./ListStockMovementsDetailRenderer.vue?vue&type=style&index=0&id=8e635602&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__